/*export const METRICS = "METRICS";
export const SEND_METRICS = "SEND_METRICS";*/
import youboraInfinity from './youboraInfinity';

const METRICS = "METRICS";
const SEND_METRICS = "SEND_METRICS";

const SET_ANALYTICS_CLIENT_TYPE = 'SET_ANALYTICS_CLIENT_TYPE';
const SET_REST_STATUS = 'SET_REST_STATUS';
const INCREMENT_EVENT_COUNT = 'INCREMENT_EVENT_COUNT';
const SET_LAST_FLUSH = 'SET_LAST_FLUSH';

export const metrics = (payload) => ({ type: METRICS, payload});
export const sendMetrics = (result) => ({ type: SEND_METRICS, result });

export const setAnalyticsClientType = (type) => ({ type: SET_ANALYTICS_CLIENT_TYPE, payload: type });
export const setRestStatus = (status) => ({ type: SET_REST_STATUS, payload: status });
export const incrementEventCount = () => ({ type: INCREMENT_EVENT_COUNT });
export const setLastFlush = (timestamp) => ({ type: SET_LAST_FLUSH, payload: timestamp });

export function decodeHTML5(text){
	const rootElement = document.getElementById('root');
	const childText = document.createElement('textarea');
	let result = "";
	rootElement.appendChild(childText);
	childText.innerHTML = text;
	result = childText.value;
	rootElement.removeChild(childText);
	return result;
}

export const setMetricsEvent = (forwardingOptions)  =>  (dispatch, getState) => {
	if(forwardingOptions.eventLabel)
		forwardingOptions.eventLabel = decodeHTML5(forwardingOptions.eventLabel);
	const options = (forwardingOptions) ? forwardingOptions : {};
	if(options.type === 'executor') {
		const { metrics } = getState();

		// Se agregan los eventos para infinity
		// Youbora
		if(typeof window.youboraAnalyticsPlugin !== 'undefined') youboraInfinity(metrics);

		return dispatch(sendMetrics({
      executor: options,
      payload: metrics.payload
    }));
	}
	return dispatch(metrics(options));
}





// WEBPACK FOOTER //
// ./src/actions/metrics.js